import {
  InMemoryCache,
  NormalizedCacheObject,
  ApolloClient,
  ApolloLink,
  HttpLink
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { BehaviorSubject } from 'rxjs';

import { authService } from '../layer0';



export type IApolloClient = ApolloClient<NormalizedCacheObject>;

const __subjClient = new BehaviorSubject<IApolloClient>(__refreshClient());



authService
  .getAuthStateObservable()
  .subscribe(({ status }) => {
    if (status === 'loggedIn' || status === 'notLoggedIn') {
      __subjClient.value.clearStore();
    }
  });


function __refreshClient() {
  const authLink = setContext(async (operation, prevContext) => {
    const authToken = (await authService.getAuthState()).accessToken;

    const headers = {
      ...prevContext.headers
    };
    if (authToken) {
      headers.authorization = `Bearer ${authToken}`;
    }

    return {
      headers
    };
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: ApolloLink.from([
      authLink,
      new HttpLink({ uri: process.env.REACT_APP_API_URL })
    ])
  });
}



export function refreshClient() {
  __subjClient.next(__refreshClient());
}



export function getClient() {
  return __subjClient.value;
}



export function getClientObservable() {
  return __subjClient.asObservable();
}
